import { render, staticRenderFns } from "./VueCollapse.vue?vue&type=template&id=2cc101f9&"
import script from "./VueCollapse.vue?vue&type=script&lang=js&"
export * from "./VueCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc101f9')) {
      api.createRecord('2cc101f9', component.options)
    } else {
      api.reload('2cc101f9', component.options)
    }
    module.hot.accept("./VueCollapse.vue?vue&type=template&id=2cc101f9&", function () {
      api.rerender('2cc101f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/components/VueCollapse.vue"
export default component.exports